import React from 'react';
import { Route } from "react-router-dom";
import InvoicesView from './invoices.view';


const InvoicesRouter = ({ match }) => (
  <div>
    <Route path={`${match.path}/:id`} component={InvoicesView} />
    <Route
      exact
      path={match.path}
      component={InvoicesView}
    />
  </div>
);

export default InvoicesRouter;
